// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/f859d7a5/" + chunkId + "." + __webpack_require__.h() + ".vf859d7a5.js";
};